<template>
  <div style="min-height: 92vh">
    <v-row>
      <v-col md="8">
        <h3>Temporadas</h3>
      </v-col>
      <v-col md="4">
        <ModuleHeader>Departamento</ModuleHeader>
        <selectDepartment></selectDepartment>
      </v-col>
    </v-row>
    <uv-data-table
      :config="config"
      :data="temporadas"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" title="Temporadas">
      <temporadaForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </temporadaForm>
    </modal>
  </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import temporadaForm from "../Temporadas/TemporadaForm.vue";

export default {
  name: "ServiciosCrud",
  components: {
    modal,
    uvDataTable,
    temporadaForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      MainDepartamento: "",
      temporadas: [],
      editData: {},
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "agregarTemp",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editTemp",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteTemp",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            title: "Fecha Inicio",
            dataName: "FechaInicio",
            text: "Fecha Inicio",
            value: "FechaInicio",
          },
          {
            title: "Fecha Termino",
            dataName: "FechaTermino",
            text: "Fecha Termino",
            value: "FechaTermino",
          },
          {
            title: "Fecha Termino",
            dataName: "FechaTermino",
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              if (row["Activo"]) {
                return '<b style="color:green;">Activo</b>';
              } else {
                return '<b style="color:red;">Inactivo</b>';
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    async getTemporadas() {
      this.temporadas = [];
      /* obtiene el listado de temporadas activas en el sistema  */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.MainDepartamento + "/Temporadas"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        this.temporadas.push({ id: element[0], ...element[1] });
      });

      this.temporadas = this.temporadas.sort(function compare(b, a) {
        var dateA = new Date(a.FechaInicio);
        var dateB = new Date(b.FechaInicio);
        return dateA - dateB;
      });
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "agregarTemp") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};

        this.toggleModal(true);
      }
      if (buttonId == "editTemp") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.temporadas,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }
      if (buttonId == "deleteTemp") {
        this.formIndex++;
        this.deleteTemporada(idSelected[0]);
      }
    },
    optButtonClick() {},
    deleteTemporada(id) {
      const deletedObject = this.$pgsHelper.getById(this.temporadas, "id", id) || { Id: id, Departamento: this.MainDepartamento };
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar la Temporada?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-eliminarTemporada", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "TEMPORADA_DELETE",
              Mensaje: "Temporada eliminada",
              reference: { id: datos.Id, tp: "RVA-Temporada", al: "TEMPORADA" },
              data: deletedObject
            });
            this.$swal(
              "La Temporada se elimino correctamente",
              "La Temporada se elimino correctamente",
              "success"
            );
            this.getTemporadas();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },

    successData(data) {
      let sendData = {
        Nombre: data.Nombre,
        Activo: data.status,
        FechaInicio: data.input_date.format("YYYY-MM-DD"),
        FechaTermino: data.input_date_final.format("YYYY-MM-DD"),
      };

      sendData.Departamento = this.MainDepartamento;

      if (data.Id == "") {
        this.createTemporada(sendData);
      } else {
        sendData.Id = data.Id;
        this.editTemporada(sendData);
      }

      //this.editProduct(data);
    },
    createTemporada(datos) {
      this.$swal({
        title: "¿Deseas agregar esta nueva temporada?",
        text: "Podras editarla y modificarla cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-crearTemporada", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            const targetId = result.value.data.id || (result.value.data.data && result.value.data.data.id) || datos.Id;
            this.$pgsHelper.writeLog({
              Evento: "TEMPORADA_CREATE",
              Mensaje: `Temporada creada: ${datos.Nombre || ""}`.trim(),
              reference: { id: targetId, tp: "RVA-Temporada", al: datos.Nombre || "TEMPORADA" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El Horario se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getTemporadas();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editTemporada(datos) {
      this.$swal({
        title: "¿Deseas editar la información de la temporada?",
        text: "Las tarifas dentro de la temporada seran ajustadas a los nuevos datos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-editarTemporada", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "TEMPORADA_EDIT",
              Mensaje: `Temporada editada: ${datos.Nombre || ""}`.trim(),
              reference: { id: datos.Id, tp: "RVA-Temporada", al: datos.Nombre || "TEMPORADA" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El Horario se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getTemporadas();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getTemporadas();

    //this.getOrigenes();
    //this.getProducts();
  },
};
</script>
